// to prevent lenis from being imported on build by default in utils.js or avoid circular dependency in main.js
import Lenis from '@studio-freight/lenis'
export const lenis = new Lenis()
// export const lenis = new Lenis({ prevent: (node) => node.classList.contains('pm--box') })
// export const lenis = new Lenis({ prevent: (node) => node.ariaModal === 'true' })
